export const X_SELLING_POPUP_GTM_CTA_LOCATION = "XSellingDialog";
